import React from "react";
import { PropsType } from "./type";
import { PacmanLoader } from "react-spinners";

const Button = (props: PropsType) => {
  const {
    children,
    variant = "filled",
    className,
    isLoading,
    label = "Login",
    tooltip,
    maxWidth,
    size,
    disabled,
    color,
    icon,
    onClick,
    animateClick,
    type,
    ...restProps
  } = props;

  const colorClass =
    color === "red"
      ? {
          btn: `${
            variant === "outlined"
              ? "bg-white hover:bg-red-50"
              : "bg-red-500 hover:bg-red-600"
          } border-red-500`,
          text: variant === "outlined" ? "text-red-500" : "text-red-100",
        }
      : color === "green"
      ? {
          btn: "bg-green-500 hover:bg-green-600 border-green-500",
          text: "text-green-100",
        }
      : color === "purple"
      ? {
          btn: "bg-gradient-to-r from-purple-300 to-purple-700 hover:to-purple-600",
          text: "text-white",
        }
      : color === "gray"
      ? {
          btn: `${
            variant === "outlined"
              ? "bg-white hover:bg-gray-50"
              : "bg-gray-50 hover:bg-gray-100"
          }`,
          text: variant === "outlined" ? "text-gray-500" : "text-gray-600",
        }
      : {
          btn: "bg-gray-950 hover:bg-gray-800 border-gray-950",
          text: "text-white",
        };

  const sizeClass =
    size === "m"
      ? { text: "text-BodyText/14/Regular", h: "h-[40px]" }
      : size === "s"
      ? { text: "text-BodyText/12/Regular", h: "h-[35px]" }
      : size === "mu"
      ? {
          text: "text-BodyText/14/Regular max-sm:text-BodyText/12/Regular",
          h: "h-[40px] max-sm:h-[35px]",
        }
      : { text: "text-Title/20/Regular", h: "h-[50px]" };

  const ClassNames =
    variant === "outlined"
      ? `flex ${
          maxWidth ? `max-w-[${maxWidth}]` : "w-full"
        } justify-center items-center bg-white ${sizeClass.h} ${
          colorClass.btn
        } rounded-xl px-4 p-2 cursor-pointer transition-all border duration-300 ${className}`
      : `flex ${
          maxWidth ? `max-w-[${maxWidth}]` : "w-full"
        } justify-center items-center ${sizeClass.h} ${
          colorClass.btn
        } rounded-xl px-4 p-2 cursor-pointer transition-all duration-300 ${className}`;
  return (
    <button
      onClick={onClick}
      className={ClassNames + " disabled:opacity-50 disabled:cursor-not-allowed"}
      type={type}
      disabled={disabled}
      {...restProps}
    >
      {isLoading ? (
        <PacmanLoader color="#ffffff" size={10} />
      ) : (
        <div className="flex gap-2">
          {icon && <img src={icon} alt="icon" />}
          <p className={`${colorClass.text} ${sizeClass.text}`}>{label}</p>
        </div>
      )}
    </button>
  );
};

export default Button;
